var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 8",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49064 1.07643L6.49065 1.07642L6.48954 1.07524C6.35678 0.933844 6.19226 0.85 6 0.85C5.81041 0.85 5.63848 0.931745 5.50861 1.07724L1.03938 5.93525L1.03936 5.93524L1.03754 5.93729C0.91453 6.076 0.85 6.24668 0.85 6.44172C0.85 6.82728 1.132 7.15 1.52419 7.15C1.71178 7.15 1.88149 7.07004 2.00481 6.94643L2.0049 6.94652L2.0091 6.94195L6 2.596L9.9909 6.94195L9.9908 6.94203L9.99519 6.94643C10.1178 7.06937 10.2816 7.15 10.4758 7.15C10.868 7.15 11.15 6.82728 11.15 6.44172C11.15 6.24658 11.0853 6.07447 10.9544 5.93476C10.9542 5.93455 10.954 5.93434 10.9538 5.93413L6.49064 1.07643Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteArrow);
export default ForwardRef;